<app-header *ngIf="router.url!='not-found'"></app-header>
<div class="content">
    <router-outlet></router-outlet>
</div>
<app-footer *ngIf="router.url!='not-found'"></app-footer>